/*
 * Trade Secrets: discount links in the French store.
 *
 * A link typed in the theme editor as /discount/CODE?redirect=%2Fcollections%2Fall (for example the hero card of an event) applies the
 * code and goes to the page, but Shopify does not add the language to a plain path, so a visitor on the French site would end up on the
 * English one. On a page of the French store this puts /fr in front of the link and of its redirect, the way the tiles in the product
 * grid (built in Liquid) already do. Nothing happens on the English pages.
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root === '/') return;
  var prefix = root.replace(/\/$/, '');

  document.querySelectorAll('a[href^="/discount/"]').forEach(function (a) {
    try {
      var url = new URL(a.getAttribute('href'), location.origin);
      var back = url.searchParams.get('redirect');
      if (back && back.charAt(0) === '/' && back.indexOf(prefix + '/') !== 0) {
        url.searchParams.set('redirect', prefix + back);
      }
      a.setAttribute('href', prefix + url.pathname + url.search);
    } catch (e) {
      /* leave the link as it is */
    }
  });
})();
